export const config = {
  rowSelection: false,
  columns: [
    {
      title: '合同标题',
      key: 'title',
      dataIndex: 'title',
      width: 200,
      ellipsis: {
        showTitle: true,
      },
    },
    {
      title: '报价类型',
      key: 'quoteTypeName',
      dataIndex: 'quoteTypeName',
      width: 200,
      ellipsis: {
        showTitle: true,
      },
    },
    {
      title: '是否线上模板',
      key: 'onlineFlag',
      dataIndex: 'onlineFlag',
      width: 120,
      ellipsis: {
        showTitle: true,
      },
      render: v => (v ? '是' : '否'),
    },
    {
      title: '关联的打印模板',
      key: 'printTemplateName',
      dataIndex: 'printTemplateName',
      width: 150,
      ellipsis: {
        showTitle: true,
      },
    },
    {
      title: '是否需要客户签字',
      key: 'customerSignFlag',
      dataIndex: 'customerSignFlag',
      width: 170,
      ellipsis: {
        showTitle: true,
      },
      render: v => (v ? '是' : '否'),
    },
    {
      title: '是否在线签',
      key: 'onlineSignFlag',
      dataIndex: 'onlineSignFlag',
      width: 120,
      ellipsis: {
        showTitle: true,
      },
      render: v => (v ? '是' : '否'),
    },
    {
      title: '创建人',
      key: 'createdByName',
      dataIndex: 'createdByName',
      width: 120,
    },
    {
      title: '创建时间',
      key: 'createdTime',
      dataIndex: 'createdTime',
      width: 180,
      itemType: 'dateTime'
    },
    {
      title: '状态',
      key: 'enabled',
      dataIndex: 'enabled',
      render: 'statusRender',
      width: 120,
    },
    {
      title: '操作',
      dataIndex: 'actions',
      width: 172,
      render: 'actionRender',
      fixed: 'right',
    },
  ],
  search: [
    {
      name: 'title',
      label: '合同标题',
    },
    {
      label: '报价类型',
      name: 'quoteType',
      itemType: 'select',
      labelKey: 'description',
      key: 'key',
      data: 'budgetRes',
    },
    {
      label: '合同类型',
      name: 'contractType',
      itemType: 'select',
      labelKey: 'description',
      key: 'key',
      data: 'contractRes',
    }
  ],
  footer: [
    {
      label: '新增',
      // auth: 'priceButton1',
      type: 'primary',
      events: ['onClick:onAdd'],
    },
  ],
  batchActions: [
    {
      label: '删除',
      // auth: 'priceButton4',
      danger: true,
      ghost: true,
      events: ['onClick:onDelete'],
    },
  ],
}
